import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Voucher } from "../types/Voucher";
import { GET_VOUCHERS_KEY } from "./useGetVouchers";
import { API, fetcher } from "@/shared/core-configs";

export const validateVoucher = async ({
  id,
  emails,
}: {
  id: string;
  emails: string[];
}): Promise<Voucher> => {
  const res = await fetcher.post(
    `${API.GESLUB_SERVICE}/voucher/${id}/validate`,
    {
      emails,
    },
  );
  return res.data;
};

export const useValidateVoucher = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: validateVoucher,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GET_VOUCHERS_KEY],
      });
    },
  });

  return {
    validateVoucher: mutateAsync,
    isPending,
  };
};
